'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { ChatWidgetLocaleContextConsumer } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import styled from 'styled-components';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NewThreadpromptContainer = styled.div.withConfig({
  displayName: "NewThreadPrompt__NewThreadpromptContainer",
  componentId: "gvh43c-0"
})(["padding:32px 20px 12px 20px;text-align:center;width:100%;"]);
function NewThreadPrompt({
  createNewThread
}) {
  return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
    children: locale => /*#__PURE__*/_jsxs(NewThreadpromptContainer, {
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newHeading",
          options: {
            locale
          }
        })
      }), /*#__PURE__*/_jsx(VizExLink, {
        "data-test-id": "visitor-widget-start-new-thread-button",
        onClick: createNewThread,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newButton",
          options: {
            locale
          }
        })
      })]
    })
  });
}
NewThreadPrompt.propTypes = {
  createNewThread: PropTypes.func.isRequired
};
NewThreadPrompt.displayName = 'NewThreadPrompt';
export default NewThreadPrompt;